'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _deep = require('helpers/deep');

var _availabilityReasons = require('constants/availability-reasons');

var _availabilityReasons2 = _interopRequireDefault(_availabilityReasons);

var _availabilityStatuses = require('constants/availability-statuses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SchedulesDeriver = function () {
  function SchedulesDeriver() {
    (0, _classCallCheck3.default)(this, SchedulesDeriver);
  }

  (0, _createClass3.default)(SchedulesDeriver, null, [{
    key: 'availabilityData',
    value: function availabilityData(schedule) {
      var availability = schedule.availability,
          _schedule$override_av = schedule.override_availabilities,
          overrideAvailabilities = _schedule$override_av === undefined ? [] : _schedule$override_av;

      var isTopUp = this.isTopUp(schedule);
      var topUpReason = (0, _deep.deepExtract)('availability.top_up.purchase.reason', schedule, null);
      var creditsReason = (0, _deep.deepExtract)('availability.credits_reasons', schedule, null);

      return {
        availableToReserve: availability.status === 'available' || isTopUp || overrideAvailabilities.some(function (override) {
          return override.purchase && override.purchase.type === 'purchase-plus';
        }),
        reasonCannotReserve: this.getReason(schedule) || null,
        reasonCode: availability.reason,
        isReserved: availability.status === _availabilityStatuses.RESERVED,
        label: availability.label || null,
        creditsReasons: isTopUp && topUpReason || creditsReason && creditsReason[0],
        availableToPurchase: this.isAvailableToPurchase(schedule)
      };
    }
  }, {
    key: 'getReason',
    value: function getReason(schedule) {
      var availability = schedule.availability;


      if (this.isAvailableToPurchase(schedule) && availability.reason === _availabilityReasons.PLAN_DOES_NOT_ALLOW_RESERVATIONS) {
        return;
      }

      return _availabilityReasons2.default[availability.reason];
    }
  }, {
    key: 'groupByDay',
    value: function groupByDay(schedules) {
      return schedules.reduce(function (memo, schedule) {
        var startDate = new Date(schedule.starttime * 1e3).toISOString().substring(0, 10);
        if (!memo[startDate]) {
          memo[startDate] = [];
        }

        memo[startDate].push(schedule);

        return memo;
      }, {});
    }
  }, {
    key: 'isAvailableToPurchase',
    value: function isAvailableToPurchase(schedule) {
      var availability = schedule.availability,
          _schedule$override_av2 = schedule.override_availabilities,
          overrideAvailabilities = _schedule$override_av2 === undefined ? [] : _schedule$override_av2;

      return !!availability.purchase || overrideAvailabilities.length > 0;
    }
  }, {
    key: 'isTopUp',
    value: function isTopUp(schedule) {
      var topUp = (0, _deep.deepExtract)('availability.top_up', schedule, null);
      return !!topUp;
    }
  }]);
  return SchedulesDeriver;
}();

exports.default = SchedulesDeriver;